import { Table } from "antd";
import { useContext, useState } from "react";
import CreateModule from "./components/CreateModule";
import UpdateModule from "./components/UpdateModule";
import DeleteModule from "./components/DeleteModule";
import { useQuery } from "@tanstack/react-query";
import { handleFetchModules } from "../../api/modules";
import Something from "../../components/shared/Something";
import { ColumnsType } from "antd/es/table";
import { AuthContext } from "../../contexts/AuthContext";
import Error from "../../components/shared/Error";
import { DeleteOutlined, EditFilled } from "@ant-design/icons";

export default function Modules() {
  const { user } = useContext(AuthContext);
  const [createModal, setCreateModal] = useState<boolean>(false);
  const [updateModal, setUpdateModal] = useState<boolean>(false);
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [selected, setSelected] = useState<any>({});
  const adminAccess = [9];

  const {
    data: modules,
    refetch,
    isLoading,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["modules"],
    queryFn: handleFetchModules,
  });
  interface DataType {
    key: React.Key;
    name: string;
    age: number;
    address: string;
  }
  const getColumns = (user: any, access: any) => {
    const columns: ColumnsType<DataType> = [
      {
        title: "S/N",
        width: 40,
        render: (record: any, text: any, index: any) => (
          <span className="text-gray-700 ml-2">{index + 1}</span>
        ),
      },
      {
        title: "CODE",
        width: 50,
        render: (record: any) => (
          <span className="text-gray-700 uppercase">{record?.code || "-"}</span>
        ),
      },
      {
        title: "NAME",
        width: 380,
        render: (record: any) => (
          <span className="text-gray-700 capitalize">
            {record?.name || "-"}
          </span>
        ),
      },
      {
        title: "MIN LEVEL",
        width: 80,
        render: (record: any) => (
          <span className="text-gray-700 capitalize">{record?.min || "-"}</span>
        ),
      },
      {
        title: "MAX LEVEL",
        width: 80,
        render: (record: any) => (
          <span className="text-gray-700 capitalize">{record?.max || "-"}</span>
        ),
      },
      {
        title: "ACTION",
        width: 180,
        render: (record: any) => (
          <div className="flex items-center">
            <button
              onClick={() => {
                setSelected(record);
                setUpdateModal(true);
              }}
              className="border py-1 px-2 mx-1 flex items-center bg-yellow-50 text-yellow-800 shadow-sm hover:bg-yellow-100"
            >
              <EditFilled />
            </button>

            <button
              onClick={() => {
                setSelected(record);
                setDeleteModal(true);
              }}
              className="border py-1 px-2 mx-1 flex items-center bg-red-50 text-red-800 shadow-sm hover:bg-red-100"
            >
              <DeleteOutlined />
            </button>
          </div>
        ),
      },
    ];
    return columns.filter((column: any) => {
      if (column.title === "ACTION") {
        return access.includes(user?.accessLevel);
      }
      return true;
    });
  };

  const columns = getColumns(user, adminAccess);

  if (!adminAccess.includes(user?.accessLevel)) {
    return <Error error="You are not authorized to access this page" />;
  }

  return (
    <div className="bg-gray-100">
      {/* <BackNav link="/autoline/requests" /> */}
      <div className="bg-white m-1">
        <div className="flex justify-between border p-2">
          <div className="">
            <div className="font-bold text-lg">Modules</div>
            <div className="text-gray-600">Manage Autoline Modules</div>
          </div>
          <div className="">
            <button
              onClick={() => setCreateModal(true)}
              className="flex mx-2 justify-center items-center border px-4 h-8 bg-karimjee hover:bg-karimjee-dark text-white shadow-sm"
            >
              + New
            </button>
          </div>
        </div>

        {isError ? (
          <Something refetch={refetch} isFetching={isFetching} />
        ) : (
          <div className="border p-2">
            <Table
              columns={columns}
              dataSource={modules}
              size="small"
              bordered
              pagination={{ pageSize: 20 }}
              scroll={{ y: 525 }}
              loading={isLoading}
              rowKey="_id"
            />
          </div>
        )}
      </div>

      <CreateModule
        isVisible={createModal}
        setVisible={setCreateModal}
        refetch={refetch}
      />

      <UpdateModule
        isVisible={updateModal}
        setVisible={setUpdateModal}
        selected={selected}
      />

      <DeleteModule
        isVisible={deleteModal}
        setVisible={setDeleteModal}
        selected={selected}
      />
    </div>
  );
}
